"use client";
import React, { useEffect, useState } from "react";

interface WavePatternProps {
  waves: number;
  color?: string;
  thickness?: number;
  className?: string;
  width?: string;
}

const WavePattern: React.FC<WavePatternProps> = ({
  waves,
  color = "#CAC0FC",
  thickness = 3,
  width = "100%",
  className,
}) => {
  const waveWidth = 117; // Width of a single wave
  const baseHeight = 25; // Original height of the wave
  const [adjustedHeight, setAdjustedHeight] = useState(baseHeight + thickness);
  const [yOffset, setYOffset] = useState(thickness / 2);

  useEffect(() => {
    setAdjustedHeight(baseHeight + thickness);
    setYOffset(thickness / 2);
  }, [baseHeight, thickness, width]);

  return (
    <svg
      className={className}
      width={waveWidth * waves}
      height={adjustedHeight}
      viewBox={`0 0 ${waveWidth * waves} ${adjustedHeight}`}
      fill="none"
      style={{
        width,
        height: "auto",
      }}
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <pattern
          id={`wave-${thickness}-${color}`}
          width={waveWidth}
          height={adjustedHeight}
          patternUnits="userSpaceOnUse"
        >
          <path
            d={`M116.809 ${23.7033 + yOffset}C87.6151 ${23.7033 + yOffset} 87.6065 ${1.29664 + yOffset} 58.4043 ${1.29664 + yOffset}C29.2022 ${1.29664 + yOffset} 29.2022 ${23.7033 + yOffset} 0 ${23.7033 + yOffset}`}
            stroke={color}
            strokeWidth={thickness}
            strokeMiterlimit="10"
          />
        </pattern>
      </defs>
      <rect
        width="100%"
        height="100%"
        fill={`url(#wave-${thickness}-${color})`}
      />
    </svg>
  );
};

export default WavePattern;
